module.exports = __webpack_public_path__ + "img/avatar6.80c575aa.png";